<template>
  <AutocompleteWithGroups
    :disabled="disabled"
    :item="item"
    :item-text="itemText"
    :item-value="itemValue"
    :items="contacts"
    :label="label"
    @updated="updated"
    :rules="rules"
    :clearable="clearable"
    :loading="loading"
    :readonly="readonly"
  ></AutocompleteWithGroups>
</template>

<script>
import AutocompleteWithGroups from "./AutocompleteWithGroups";
export default {
  name: "AutocompleteContacts",
  components: { AutocompleteWithGroups },
  props: {
    item: {
      type: String
    },
    label: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    itemText: {
      type: String,
      default: "name"
    },
    itemValue: {
      type: String,
      default: "id"
    },
    updated: {
      type: Function,
      default: function() {
        return new Function();
      }
    },
    rules: {
      type: Array,
      default: () => []
    },
    clearable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    contacts: {
      get() {
        let contacts = this.$store.getters["contactStore/getList"];
        let groupContacts = contacts.reduce((ac, val) => {
          val.name = val.organization_name
            ? val.organization_name
            : val.family_name + " " + val.given_name;
          val.group = val._addressbook.name || "Other";
          ac[val.group] ? ac[val.group].push(val) : (ac[val.group] = [val]);
          return ac;
        }, {});
        return Object.keys(groupContacts)
          .sort(function(a, b) {
            return a.toLowerCase().localeCompare(b.toLowerCase());
          })
          .reduce((ac, val) => {
            ac.push({ name: val, disabled: true }, ...groupContacts[val]);
            return ac;
          }, []);
      }
    }
  },
  mounted() {
    this.$store.dispatch("contactStore/getList", {
      params: { limit: -1 }
    });
  }
};
</script>

<style scoped></style>
